import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { Dropdown } from '@ami/react/core';
import { FormDropdown } from '@ami/react/core';
import { Input } from '@ami/react/core';
import { CreateQuoteStep1 } from '../otherQuoteEntities';
import { makeConcealable } from '@ami/react/core';
import { Machine } from '../../machines/machine';
import { FlatWeightCategory } from '../../products/productConfiguration';
import _ from 'lodash';
import { machineStatus } from '../../machines/machineStatusType';

const otherMachineId = 'OTHER-MACHINE';

class CreateQuoteMakeAndModelComponent extends Component {
  state = {
    isOtherMachineBeingEntered: false,
  };
  static propTypes = {
    data: PropTypes.instanceOf(CreateQuoteStep1).isRequired,
    preferredMakeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    onUpdate: PropTypes.func.isRequired,
    manufacturers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    machines: PropTypes.arrayOf(PropTypes.instanceOf(Machine)).isRequired,
    weightCategories: PropTypes.arrayOf(
      PropTypes.instanceOf(FlatWeightCategory)
    ).isRequired,
  };

  getFilteredMachines() {
    const filteredModels = _.flowRight(
      this.mapToModel(this.props.weightCategories),
      this.filterMachineByManufacturer,
      this.filterMachineByCategory,
      this.filterMachineByStatus
    )(this.props.machines);
    filteredModels.unshift({ id: otherMachineId, label: 'Other' });
    return filteredModels;
  }

  filterMachineByCategory = (machines) => {
    return machines.filter((x) => x.carrierId === this.props.data.carrierId);
  };

  filterMachineByManufacturer = (machines) =>
    machines.filter((x) => x.manufacturer === this.props.data.manufacturer);

  filterMachineByStatus = (machines) => {
    return machines.filter((x) => x.status === machineStatus.Approved);
  };

  mapToModel = (weightCategories) => (machines) =>
    machines.map((machine) => {
      const category = weightCategories.find(
        (w) => w.id === machine.weightCategoryId
      );
      return {
        id: machine.id,
        label: machine.model,
        description: category.label,
        weightCategoryId: category.id,
        weightCategoryLabel: category.label,
        weightCategoryDescription: category.description,
      };
    });

  mapToManufacturer = (machines) => {
    return machines.map((x) => ({
      id: x.manufacturer,
      label: x.manufacturer,
    }));
  };

  sortManufacturesByLabel = (manufacturers) => {
    const preferredMakeIds = this.props.preferredMakeIds;
    const sorted = _.sortBy(manufacturers, (x) => x.label);
    const firstPriority = [];
    const lastPriority = [];
    sorted.forEach((item) => {
      if (preferredMakeIds.includes(item.label)) firstPriority.push(item);
      else lastPriority.push(item);
    });
    return [...firstPriority, ...lastPriority];
  };

  removeDuplicatesByLabel = (items) => _.uniqBy(items, (x) => x.label);

  handleMachineSelected = (machineId) => {
    const isOtherMachineBeingEntered = machineId === otherMachineId;
    this.setState({ isOtherMachineBeingEntered });
    if (isOtherMachineBeingEntered) {
      this.clearMachineData();
    } else {
      var machine = this.getFilteredMachines().find((x) => x.id === machineId);
      this.props.onUpdate({
        machineId,
        weightCategoryId: machine.weightCategoryId,
        weightCategoryLabel: machine.weightCategoryLabel,
        weightCategoryDescription: machine.weightCategoryDescription,
      });
    }
  };

  clearMachineData = () => {
    this.props.onUpdate({
      machineId: null,
      model: '',
      weightCategoryId: null,
      weightCategoryLabel: null,
      weightCategoryDescription: null,
    });
  };

  onEnterOtherMachineShortcut = () => {
    this.setState({ isOtherMachineBeingEntered: true });
    this.clearMachineData();
  };

  render() {
    const { data, onUpdate, manufacturers } = this.props;
    const carrierWeightCategories = this.props.weightCategories.filter(
      (x) => x.carrierId === data.carrierId
    );

    const { isOtherMachineBeingEntered } = this.state;

    return (
      <div className="row">
        <div className="col-md-4 offset-md-2">
          <FormDropdown
            label="Make"
            placeholder="Select a make..."
            items={manufacturers}
            selectedId={data.manufacturer}
            onChange={(manufacturer) =>
              onUpdate({ manufacturer, machineId: null, model: '' })
            }
            required
            forceSearchable={true}
          />
        </div>
        <div className="col-md-4">
          <FormGroup>
            <div style={{ display: 'inline-block', width: '100%' }}>
              <Label className="form-label">Model</Label>
              <button
                type="button"
                className="btn btn-link p-0 pull-right"
                onClick={() => this.onEnterOtherMachineShortcut()}
              >
                enter other model
              </button>
            </div>
            <Dropdown
              placeholder="Select a model..."
              items={this.getFilteredMachines()}
              selectedId={
                isOtherMachineBeingEntered ? otherMachineId : data.machineId
              }
              onChange={(machineId) => this.handleMachineSelected(machineId)}
              required={!isOtherMachineBeingEntered}
              forceSearchable={true}
            />
          </FormGroup>
          {isOtherMachineBeingEntered && (
            <Fragment>
              <Input
                className="mb-2"
                placeholder="Enter the machine's model number"
                value={data.model}
                onChange={(e) => onUpdate({ model: e.target.value })}
                required
              />
              <Dropdown
                placeholder="Select the machine's weight category"
                items={carrierWeightCategories}
                selectedId={data.weightCategoryId}
                onChange={(id) => {
                  const category = carrierWeightCategories.find(
                    (x) => x.id === id
                  );
                  onUpdate({
                    weightCategoryId: category.id,
                    weightCategoryLabel: category.label,
                    weightCategoryDescription: category.description,
                  });
                }}
                required
              />
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default makeConcealable(CreateQuoteMakeAndModelComponent);
